import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

const A = styled.a`
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 24px;
  color: #c7a878;

  &:focus {
    outline-color: #c7a878;
    color: #c7a878;
  }

  &:hover {
    text-decoration: none;
    color: #c7a878;
  }
`;

const CLink = styled(Link)`
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 24px;
  color: #c7a878;

  &:focus {
    outline-color: #c7a878;
    color: #c7a878;
  }

  &:hover {
    color: #c7a878;
    transform: translateY(-0.5px);
  }
`;

export { A, CLink };
